define( 'modules/tester/Stats',['require','exports','module'],function(require, exports, module) {"use strict";

	// For IE8 and earlier version.
	if (!Date.now) {
		Date.now = function() {
			return new Date().valueOf();
		};
	}

	var startTime = Date.now();
	var prevTime = startTime;
	var fps = 0;
	var fpsMin = Infinity;
	var fpsMax = 0;
	var frames = 0;

	var Stats = {

		Begin : function() {
			startTime = Date.now();
		},

		End : function() {
			var time = Date.now();

			frames++;

			if (time > prevTime + 1000) {

				fps = Math.round((frames * 1000 ) / (time - prevTime ));
				fpsMin = Math.min(fpsMin, fps);
				fpsMax = Math.max(fpsMax, fps);

				prevTime = time;
				frames = 0;

			}

			return time;
		},

		Update : function() {
			startTime = this.End();
		},

		getFps : function() {
			return fps;
		},

		getFpsMin : function() {
			return fpsMin;
		},

		getFpsMax : function() {
			return fpsMax;
		}
	};

	module.exports = Stats;

});

